import axios, { AxiosRequestConfig, isAxiosError } from 'axios';
import { useState } from 'react';

type UploadState = {
    file: File | null;
    isLoading: boolean;
    error: string | null;
    response: string | number | null;
    handleFileChange: (files: File[]) => void;
    handleUpload: () => Promise<void>;
    handleFileRemove: () => void;
    handleResetStatus: () => void;
}

export const useUploadFile = (url: string): UploadState => {
    const [file, setFile] = useState<File | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [response, setResponse] = useState<string | number | null>(null);

    const handleUpload = async () => {
        if (!file) {
            setError('Erro: Nenhum arquivo selecionado.');
            return;
        }

        setIsLoading(true);
        setError(null);

        const config: AxiosRequestConfig = {
            maxBodyLength: Infinity,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer 6873b7bdb607654646610c860ae94128'
            }
        };

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axios.post<string | number>(url, formData, config);
            setResponse(response.data);
        } catch (error) {
            const message = isAxiosError(error) && error.response ? 
                `${error.response.status} - ${error.response.statusText}` :
                `Ocorreu um erro inesperado: ${(error as Error).message}`;
            setError(message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleFileChange = (files: File[]) => {
        if (files.length > 0) {
            setFile(files[0]);
        }
    };

    const handleFileRemove = () => {
        setFile(null);
    };

    const handleResetStatus = () => {
        setFile(null);
        setResponse(null);
        setIsLoading(false);
        setError(null);
    };

    return {
        file,
        isLoading,
        error,
        response,
        handleUpload,
        handleFileChange,
        handleFileRemove,
        handleResetStatus
    };
};
